<template>
    <v-layout class="get-cost"
                    style="max-width: 1240px"
        >
            <h3>Введите гос. номер и мы заполним данные по автомобилю за вас</h3>
            <v-form ref="form" v-on:submit.prevent="getByNumber">
                <v-flex>
                    <v-flex d-flex class="field-block gos-number-block">
                        <span class="alert-russian-symbols" v-if="!symbolsRussian">Могут использоваться только русские буквы</span>
                        <v-text-field
                            :label="placeholder"
                            v-model="gosNumber"
                            :rules="[rules.required, rules.number, rules.minCount]"
                            validate-on-blur
                            required
                            v-mask="'G QQQ GG QQQ'"
                            @focus="onFocusTextField"
                            @blur="onBlurTextField"
                            @input="onInputGosNumber"
                            ref="gosNumberInput"
                            class="field-upper-text"
                        />
                        <v-btn
                            class="button next-button block"
                            @click="getByNumber"
                            v-html="buttonText"
                        >
                        </v-btn>
                    </v-flex>
                    <div class="count-without-number">
                        <a
                            @click="countWithoutGosNumber"
                            :loading="this.wait"
                        >
                            Нет гос. номера
                        </a>
                    </div>
                </v-flex>
            </v-form>
        </v-layout>
</template>
<script>
    import ymMixin from '../../mixins/ym';

    export default {
        mixins: [ymMixin],
        name: 'CalcForm',
        props: ['buttonText'],
        data: () => ({
            gosNumber: null,
            preloading: false,
            wait: false,
            placeholder: 'Введите гос. номер',
            placeholderDefault: 'Введите гос. номер',
            symbolsRussian: true,
            lengthGosNumber: 0,
            flag: 0,
            rules: {
                    required: v => !!v || 'Обязательное поле',
                    number: v => /^[АВЕКМНОРСТУХ_\d\s]{4,}$/.test(v) || 'Неверный формат',
                    minCount: v => ( v && v.replace(/(?!-)[^0-9А-Я]/g, "").length >=8 ) || 'Введите номер автомобиля',
            },
        }),
        methods: {
            onInputGosNumber(value){
                let string = value.replace(/(?!-)[^a-zA-Z0-9а-яА-Я]/g, "")

                if (this.flag == 0) {
                    this.flag = 1
                    if (/[a-zA-Z]/.test(string)) {
                        this.symbolsRussian = false
                    } else {
                        this.symbolsRussian = true
                    }
                } else {
                    this.flag = 0
                }
                if (string == '' || value.slice(-1) == ' ') {
                    this.flag = 0
                }
                this.gosNumber = this.gosNumber.toUpperCase()
            },

            getByNumber() {
                if (!this.$refs.form.validate()) {
                    return
                }
                this.gosNumber = this.gosNumber.replace(/(?!-)[^0-9А-Я]/g, "")
                this.reachGoal('input_gosnumber')
                this.toLoad()
            },

            toLoad() {
                document.location.href = '/calc?gosNumber=' + this.gosNumber
            },

            countWithoutGosNumber() {
                document.location.href = '/calc?gosNumber=none'
            },

            onFocusTextField() {
                this.placeholder = 'А 123 АА 777'
            },

            onBlurTextField() {
                if (!this.gosNumber) {
                    this.placeholder = this.placeholderDefault
                } else {
                    this.placeholder = null
                }
            }
        }
    }
</script>
<style scoped>
    .gos-number-block {
        position: relative;
        width: 100%;
    }
    .alert-russian-symbols {
        position: absolute;
        top: -5px;
        color: #ff5252;
        font-size: 14px;
    }

    .get-cost {
        display: block;
    }
    .get-cost h3 {
        font-size: 18px;
        line-height: 1.55;
        font-weight: 400;
        text-align: center;
        width: 360px;
        max-width: 100%;
        margin: 0 auto;
        margin-bottom: 20px;
        margin-top: 40px;
    }
    .get-cost .field-block {
        padding: 20px 0;
        width: 100%;
        margin: 0 auto;
    }
    .get-cost .field-block .v-text-field {
        padding: 0;
        margin-right: 21px;
    }
    .get-cost .field-block .button {
        margin: 0;
        max-width: 240px;
    }
    .get-cost .field-block .button .v-btn__content {
        padding: 0;
        width: 100%;
    }
    .get-cost .count-without-number {
        text-align: center;
    }
    .get-cost .count-without-number a {
        text-decoration: underline;
        color: #00ba57;
        line-height: 1.55;
        font-weight: 400;
        font-size: 16px;
    }
    .button {
        line-height: 1.45 !important;
        font-weight: 700 !important;
        font-size: 18px !important;
        text-transform: none !important;
        box-shadow: none !important;

        width: 250px;
        height: 60px;
        text-align: center;
        display: table-cell;
        vertical-align: middle;
        padding: 0 !important;
        margin: 10px 20px 0 0;

        border-width: 1px;
        border-radius: 100px;
        border-style: solid;
    }

    .button >>> .v-btn__content {
        white-space: normal;
        line-height: 1.1;
    }

    .next-button {
        color: #ffffff !important;
        background-color: #00ba57 !important;
        border-color: transparent;
    }

    @media(max-width: 960px) {
        .gos-number-block{
            flex-direction: column;
        }
        .get-cost .field-block .v-text-field {
            margin-right: 0;
        }
        .get-cost .field-block {
            width: 100%;
        }
        .button {
            width: 100%;
        }
        .get-cost .field-block .button {
            max-width: 100%;
        }
        .get-cost h3{
            text-align: left;
            font-size: 14px;
            margin-bottom: 0;
        }
    }
</style>



// WEBPACK FOOTER //
// resources/js/components/elements/CalcForm.vue